<template>
  <div class="container-fluid">
    <main role="main">
      <div class="hello">
        <p>{{ msg }}</p>
        <canvas id="emotion-canvas" ref="emotioncanvas" v-bind:width="canvasWidth" v-bind:height="canvasHeight" style="background-color: #000;"></canvas>
        <p>logo</p>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'EmotionStep',
  props: {
    msg: String
  },

  computed: {
    canvas: function () {
      // Get canvas drawing context from canvas element
      return this.$refs.emotioncanvas.getContext('2d')
    },
    canvasWidth () {
      return this.$store.getters.windowWidth - 20
    },
    canvasHeight () {
      return this.$store.getters.windowHeight - 20
    },
  },

  mounted () { // Setup
    this.drawCanvas()
  },
  updated () { // Loop
    this.drawCanvas()
  },

  methods: {
    drawCanvas () {
      let resizeText = 'Canvas width: ' + this.canvasWidth + 'px, height ' + this.canvasHeight + 'px'
      this.canvas.textAlign = 'center'
      this.canvas.fillStyle = '#fff'
      this.canvas.fillText(resizeText, 200, 200)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
